import { render, staticRenderFns } from "./printer_pos_plus.vue?vue&type=template&id=96f9c348"
import script from "./printer_pos_plus.vue?vue&type=script&lang=js"
export * from "./printer_pos_plus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports